import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { CustomSelect, postData } from "../Commonfunction/CommonFunction";
import { toast } from "react-toastify";
import { Field, Form, Formik } from "formik";
import FormHeading from "../common/FormHeading";
import HistoryData from "./HistoryData";
import * as Yup from "yup";
import PdfGenerator from "../common/PDFComponents";

export default function CustomersFileHistoryFilterForMonthWise({
  addTax = false,
  monthWiseRow,
  monthData,
  isPDF=true,
}) {
  const [value, setValue] = useState("0");
  const [tableData, setTableData] = useState([]);
  console.log("****",tableData)
  const [isLoading, setIsLoading] = useState(false);
  const { id } = useParams();
  const location = useLocation();
  const monthName = location.state?.state || monthData.state.state;
  const fileData = location.state?.fileData || monthData.state.fileData;
  const [ cusData, setCusData ] = useState();

  
  const fetchData = async () => {
    try {
      let apiEndpoint = "";
      if (value === "1") {
        apiEndpoint = `/api/get-all-customer-files-by-current-financial-year/${id}`;
      } else if (value === "2") {
        apiEndpoint = `/api/get-all-customer-files-by-previous-financial-year/${id}`;
      } else if (value === "3") {
        apiEndpoint = `/api/customer-all-files/${id}`;
      } else {
        setIsLoading(true);
        apiEndpoint = `/api/tax-calculation-report-export-compile-month/${id}`;
      }
      const data = new Date();
      const currentMonth = data.getMonth() + 1;
      const currentYear = data.getFullYear();
      const monthNumber = getMonthNumber(monthName?.month);
      const result = await postData(apiEndpoint, {
        year: monthName?.year,
        filter_type: "annual",
        month: monthNumber,
      });
      if (result) {
        const values = {
          year: monthName?.year,
          value: "annual",
          month: monthNumber,
        };
        let { customerdata, taxhead, ...updatedQty } = result;
        setCusData(result)
        const qtyOne = removeMainObject(updatedQty, customerdata);
        const singleMonthData = transformData(qtyOne);
        const monthData = await getFullMonthData(
          singleMonthData,
          monthName?.month
        );
        console.log("monthData", monthData);
        await setTableData(monthData);
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("Failed to fetch data");
      setIsLoading(false);
    }
  };

  function getFullMonthData(monthData, month) {
    if (monthData[month]) {
      return { [month]: monthData[month] };
    } else {
      console.warn(`${month} data does not exist.`);
      return {};
    }
  }

  const getMonthNumber = (monthName) => {
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    const monthIndex = months.findIndex(
      (month) => month?.toLowerCase() === monthName?.toLowerCase()
    );

    if (monthIndex === -1) {
      throw new Error("Invalid month name");
    }

    return String(monthIndex + 1).padStart(2, "0");
  };

  function removeMainObject(data, customerdata) {
    // Keep your existing implementation
    let newData = {};

    for (const month in data) {
      if (data[month]?.hasOwnProperty("Calculation_Total")) {
        const calculationTotal = data[month]["Calculation_Total"];
        let updatedMonthData = { ...data[month] };

        if (
          customerdata?.business_type === "Hotel - Motel" &&
          updatedMonthData?.HOTEL_OCCUPANY?.Room_Tax
        ) {
          updatedMonthData["Room_Occupacy_Tax"] =
            updatedMonthData["HOTEL_OCCUPANY"]["Room_Tax"];
          delete updatedMonthData["HOTEL_OCCUPANY"]["Room_Tax"];
        } else if (customerdata?.business_type === "Tennessee") {
          updatedMonthData = { "": "", ...updatedMonthData };
        } else {
          if (calculationTotal?.["Gross_Non_fuel_sale"] !== undefined) {
            updatedMonthData = {
              Gross_Non_fule: {
                Gross_Non_fuel_sale: calculationTotal["Gross_Non_fuel_sale"],
              },
              ...updatedMonthData,
            };
          }
        }

        data[month] = updatedMonthData;
      }

      if (data[month].hasOwnProperty("Tax_Return_upload")) {
        delete data[month].Tax_Return_upload;
      }

      if (data[month].hasOwnProperty("Main")) {
        delete data[month]["Main"];
      }

      for (const category in data[month]) {
        const currentObj = data[month][category];
        if (
          ["Gas", "Diesel", "Other"].includes(category) &&
          currentObj.hasOwnProperty("Total")
        ) {
          delete currentObj["Total"];
        }
        if (
          ["Calculation_Total"].includes(category) &&
          currentObj.hasOwnProperty("Gross_Non_fuel_sale")
        ) {
          delete currentObj["Gross_Non_fuel_sale"];
          delete currentObj["Total_Gas_Diesel_gallon"];
          delete currentObj["Total_Gas_Diesel_sale"];
          delete currentObj["Total_Gas_Diesel_sale_MIn"];
        }

        if (currentObj.hasOwnProperty("Total")) {
          const totalValue = currentObj["Total"];
          delete currentObj["Total"];
          currentObj["Total"] = totalValue;
        }
        if (currentObj.hasOwnProperty("Total_Amount_Due")) {
          const TotalAmountDue = currentObj["Total_Amount_Due"];
          currentObj["Final_Total_Amount_Due"] = TotalAmountDue;
        }
      }
    }
    return data;
  }

  const transformData = (data) => {
    const result = {};

    for (const [month, details] of Object.entries(data)) {
      result[month] = {};

      for (const [key, value] of Object.entries(details)) {
        if (typeof value === "object" && !Array.isArray(value)) {
          result[month][key] = Object.entries(value).map(
            ([subKey, subValue]) => {
              return { [subKey]: subValue };
            }
          );
        } else {
          result[month][key] = [{ [key]: value }];
        }
      }
    }

    return result;
  };
  
  const getTableData = async (qtyOne, values) => {
    const filter = values.value; // q1, q2, q3, q4, annual
    const availableMonths = Object.keys(qtyOne);
    // This is Common Qty Month Function
    const qtyMonth = (months) => {
      months.forEach((month) => {
        if (!availableMonths.includes(month)) {
          // If no reference month is available, throw an error
          if (availableMonths.length === 0) {
            throw new Error(
              "No reference data available to construct missing months."
            );
          }

          // Use the first available month as a reference
          const referenceMonth = availableMonths[0];
          const newMonthData = {};

          // Dynamically create the structure for the missing month with zero values
          Object.keys(qtyOne[referenceMonth]).forEach((category) => {
            newMonthData[category] = {};
            Object.keys(qtyOne[referenceMonth][category]).forEach((key) => {
              newMonthData[category][key] = 0; // Set all values to zero
            });
          });

          // Find the position of the missing month in the months array
          let monthIndex = months.indexOf(month);

          // Insert the missing month at the correct position in qtyOne
          if (monthIndex === 0) {
            // If the missing month is at the start
            qtyOne = { [month]: newMonthData, ...qtyOne };
          } else if (monthIndex === months.length - 1) {
            // If the missing month is at the end
            qtyOne[month] = newMonthData;
          } else {
            // Insert the missing month in the middle
            let beforeMonth = months[monthIndex - 1];
            let afterMonth = months[monthIndex + 1];

            let updatedQtyOne = {};
            Object.keys(qtyOne).forEach((key) => {
              updatedQtyOne[key] = qtyOne[key];
              if (key === beforeMonth) {
                updatedQtyOne[month] = newMonthData; // Insert the missing month after the `beforeMonth`
              }
            });

            // Ensure the remaining months after the insertion are added
            if (!(month in updatedQtyOne)) {
              updatedQtyOne[month] = newMonthData;
            }

            qtyOne = updatedQtyOne;
          }
          // console.log(`Inserted missing month: ${month}`, qtyOne);
        }
      });
    };
    
    const calculateQuarter = (months) => {
      const quarter = {};

      months.forEach((month) => {
        const monthData = qtyOne[month];
        // Iterate over each category (like "High", "Low", "Gas") to sum the values dynamically
        Object.keys(monthData).forEach((category) => {
          if (!quarter[category]) {
            quarter[category] = {};
          }

          // Sum the corresponding totals dynamically
          Object.keys(monthData[category]).forEach((key) => {
            if (!quarter[category][key]) {
              quarter[category][key] = 0;
            }
            quarter[category][key] += monthData[category][key];
          });
        });
      });
      return quarter;
    };

    if (filter == "q1") {
      // Check if any month is missing
      const months = ["January", "February", "March"];
      qtyMonth(months);
      const qtrOneData = calculateQuarter(["January", "February", "March"]);
      qtyOne["Q1 Total"] = qtrOneData;

      // console.log('qtyOne', qtyOne);
      const transformedData = transformData(qtyOne);
      await setTableData(transformedData);
    } else if (filter == "q2") {
      // Check if any month is missing
      const months = ["April", "May", "June"];
      qtyMonth(months);
      const qtrOneData = calculateQuarter(["April", "May", "June"]);
      qtyOne["Q2 Total"] = qtrOneData;
      // console.log('qtyOne', qtyOne);
      const transformedData = transformData(qtyOne);
      await setTableData(transformedData);
    } else if (filter == "q3") {
      // Check if any month is missing
      const months = ["July", "August", "September"];
      qtyMonth(months);
      const qtrOneData = calculateQuarter(["July", "August", "September"]);
      qtyOne["Q3 Total"] = qtrOneData;
      // console.log('qtyOne', qtyOne);
      const transformedData = transformData(qtyOne);
      await setTableData(transformedData);
    } else if (filter == "q4") {
      // Check if any month is missing
      const months = ["October", "November", "December"];
      qtyMonth(months);
      const qtrOneData = calculateQuarter(["October", "November", "December"]);
      qtyOne["Q4 Total"] = qtrOneData;
      // console.log('qtyOne', qtyOne);
      const transformedData = transformData(qtyOne);
      await setTableData(transformedData);
    } else {
      const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      qtyMonth(months);
      // // Calculate the quarterly totals for Q1, Q2, Q3, and Q4
      const qtrOneData = calculateQuarter(["January", "February", "March"]);
      const qtrTwoData = calculateQuarter(["April", "May", "June"]);
      const qtrThreeData = calculateQuarter(["July", "August", "September"]);
      const qtrFourData = calculateQuarter(["October", "November", "December"]);

      // Add the quarterly data to the original data object
      qtyOne["Q1 Total"] = qtrOneData;
      qtyOne["Q2 Total"] = qtrTwoData;
      qtyOne["Q3 Total"] = qtrThreeData;
      qtyOne["Q4 Total"] = qtrFourData;

      // Calculate the overall total by summing Q1, Q2, Q3, and Q4 totals
      const total = {};

      const addQuarterData = (quarterData) => {
        Object.keys(quarterData).forEach((category) => {
          if (!total[category]) {
            total[category] = {};
          }

          Object.keys(quarterData[category]).forEach((key) => {
            if (!total[category][key]) {
              total[category][key] = 0;
            }
            total[category][key] += quarterData[category][key];
          });
        });
      };

      addQuarterData(qtrOneData);
      addQuarterData(qtrTwoData);
      addQuarterData(qtrThreeData);
      addQuarterData(qtrFourData);

      qtyOne["Total"] = total;
      // console.log('Final qtyOne:', qtyOne);
      const desiredOrder = [
        "January",
        "February",
        "March",
        "Q1 Total",
        "April",
        "May",
        "June",
        "Q2 Total",
        "July",
        "August",
        "September",
        "Q3 Total",
        "October",
        "November",
        "December",
        "Q4 Total",
        "Total",
      ];
      const reorderedData = Object.fromEntries(
        desiredOrder.map((key) => [key, qtyOne[key]])
      );
      const transformedData = transformData(reorderedData);
      await setTableData(transformedData);
      // console.log('reorderedData==', transformedData);
    }
  };

  const maskNumber = (number) => {
    const numberString = number?.toString();
    const lastFourDigits = numberString?.slice(-4);
    const maskedSection = "*"?.repeat(numberString?.length - 4);
    return maskedSection + lastFourDigits;
  };

  useEffect(() => {
    fetchData();
  }, [value]);

  useEffect(() => {
    if (addTax) {
      fetchData();
    }
  }, []);

  const validationSchemaFilterModal = Yup.object().shape({
    year: Yup.string().required("Year is required"),
    filter_type: Yup.string().required("Filter type is required"),
  });

  const filterOptions = [
    { value: "q1", label: "Quarter 1" },
    { value: "q2", label: "Quarter 2" },
    { value: "q3", label: "Quarter 3" },
    { value: "q4", label: "Quarter 4" },
    { value: "annual", label: "Annually" },
  ];

  const yearOptions = Array.from({ length: 20 }, (_, i) => {
    const year = new Date().getFullYear() - i;
    return { value: year.toString(), label: year };
  });

  const handleSubmit = async (FinalValue) => {
    try {
      const postDataResult = await postData(
        `/api/tax-calculation-report-export-compile/${id}`,
        FinalValue
      );

      if (postDataResult) {
        const values = {
          year: FinalValue.year,
          value: FinalValue.filter_type,
        };
        let { customerdata, taxhead, ...updatedQty } = postDataResult;
        const qtyOne = removeMainObject(updatedQty, customerdata);
        await getTableData(qtyOne, values);
      }
    } catch (error) {
      console.error("Error submitting data:", error);
    }
  };

  return (
    <React.Fragment>
      {addTax && (
        <div className="display-flex flex-wrap">
          <Formik
            initialValues={{
              year: "",
              filter_type: "",
            }}
            validationSchema={validationSchemaFilterModal}
            onSubmit={(values) => handleSubmit(values)}
          >
            {({ errors, touched }) => (
              <Form className="width-full">
                <div className="grid-row grid-gap">
                  <div className="grid-col-2">
                    <label htmlFor="year" className="usa-label">
                      Select Year <span className="text-secondary">*</span>
                    </label>
                    <Field
                      name="year"
                      component={CustomSelect}
                      options={yearOptions}
                    />
                    {errors.year && touched.year && (
                      <div className="usa-error-message">{errors.year}</div>
                    )}
                  </div>

                  <div className="grid-col-2">
                    <label htmlFor="filter_type" className="usa-label">
                      Filter Type <span className="text-secondary">*</span>
                    </label>
                    <Field
                      name="filter_type"
                      component={CustomSelect}
                      options={filterOptions}
                    />
                    {errors.filter_type && touched.filter_type && (
                      <div className="usa-error-message">
                        {errors.filter_type}
                      </div>
                    )}
                  </div>

                  <div className="grid-col-3 margin-top-3">
                    <button type="submit" className="usa-button">
                      Filter Data
                    </button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      )}

      <div>
        {isLoading ? (
          <p>Loading ...</p>
        ) : (
          <>
            <div className="width-full padding-2">
              <div className="client-info-card">
                <FormHeading
                  heading={"Client File Details By Month"}
                  path={`/customer-file/${id}`}
                  state={fileData}
                  isPassState={true}
                />
                <div className="info-grid">
                  <div className="info-item">
                    <label>Customer File No</label>
                    <span>{monthName?.customer_file_no}</span>
                  </div>
                  <div className="info-item">
                    <label>Company Name</label>
                    <span>{monthName?.company_name}</span>
                  </div>
                  <div className="info-item">
                    <label>DBA Name</label>
                    <span>{monthName?.dba_name}</span>
                  </div>
                  <div className="info-item">
                    <label>S&U Number</label>
                    <span>{monthName?.s_and_u_number}</span>
                  </div>
                  <div className="info-item">
                    <label>Year</label>
                    <span>{monthName?.year}</span>
                  </div>
                  <div className="info-item">
                    <label>Month</label>
                    <span>{monthName?.month}</span>
                  </div>
                  <div className="info-item">
                    <label>Mobile Number</label>
                    <span>{monthName?.mobile_no}</span>
                  </div>
                  <div className="info-item">
                    <label>Account Number</label>
                    <span>
                      {monthName?.bank_account_no?.length > 6
                        ? maskNumber(monthName?.bank_account_no)
                        : monthName?.bank_account_no}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className="grid-row padding-2">
              <div className="grid-col-5">
                <h3 className="font-sans-lg text-primary-darker margin-y-5">
                  Customers File{" "}
                  <span style={{ color: "#1976d2" }}>{monthName?.month}</span>{" "}
                  Month History
                </h3>
              </div>

              <div className="grid-col-7 display-flex flex-justify-end flex-align-center margin-top-4">
                {/* Replace the buttons with the PdfGenerator component */}
                <PdfGenerator 
                  tableData={tableData} 
                  monthName={monthName}
                  cusData={cusData}
                />
              </div>

              <div className="grid-col-12">
                <HistoryData
                  historyMainData2={tableData}
                  historyMainData={tableData}
                  addTax={addTax}
                  height={"60vh"}
                />
              </div>
            </div>
          </>
        )}
      </div>
    </React.Fragment>
  );
}